'use client';

import React, { Fragment } from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Leftnav from '../components/Leftnav';
import Rightchat from '../components/Rightchat';
import Appfooter from '../components/Appfooter';
import Popupchat from '../components/Popupchat';

import Postview from '../components/Postview';
import Events from '../components/Events';
import Createpost from '../components/Createpost';
import Load from '../components/Load';
import Profilephoto from '../components/Profilephoto';
import ProfilecardOne from '../components/ProfilecardOne';
import Profiledetail from '../components/Profiledetail';

const Grouppage: React.FC = () => {
    const user = useAuth()?.user || (typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user') || 'null') : null);

    return (
        <Fragment>
            <Header />
            <Leftnav />
            <Rightchat />

            <div className="main-content right-chat-active">
                <div className="middle-sidebar-bottom">
                    <div className="middle-sidebar-left pe-0">
                        <div className="row">
                            <div className="col-xl-4 col-xxl-3 col-lg-4 pe-0">
                                <ProfilecardOne />
                                <Profiledetail />
                                <Profilephoto />
                                <Events />
                            </div>
                            <div className="col-xl-8 col-xxl-9 col-lg-8 mt-3">
                                <Createpost autorAtleta={user?.atleta} />
                                <Postview id="32" postvideo="" username='username' postimage="post.png" avater="user.png" user="Surfiya Zakir" time="22 min ago" des="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nulla dolor, ornare at commodo non, feugiat non nisi. Phasellus faucibus mollis pharetra. Proin blandit ac massa sed rhoncus." />
                                <Postview id="31" postvideo="" postimage="post.png" username='username'avater="user.png" user="David Goria" time="22 min ago" des="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nulla dolor, ornare at commodo non, feugiat non nisi. Phasellus faucibus mollis pharetra. Proin blandit ac massa sed rhoncus." />
                                <Postview id="33" postvideo="" postimage="post.png" avater="user.png" username='username' user="Anthony Daugloi" time="2 hour ago" des="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi nulla dolor, ornare at commodo non, feugiat non nisi. Phasellus faucibus mollis pharetra. Proin blandit ac massa sed rhoncus." />
                                <Load />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Popupchat />
            <Appfooter />

        </Fragment>
    )
}

export default Grouppage